(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watany-browse"] && !Shopify.designMode) return;
  try {
    
class WatanyBrowse extends HTMLElement {
  connectedCallback() {
    const size=this.querySelector('[data-size]'); if(!size || this.dataset.ready) return; this.dataset.ready='true';
    const stock=this.querySelector('[data-stock]'), sort=this.querySelector('[data-sort]'), grid=this.querySelector('[data-grid]'), items=[...grid.querySelectorAll('[data-item]')];
    const sizes=[...new Set(items.flatMap(item=>item.dataset.sizes.split('|').filter(Boolean)))];
    const order=['XXS','XS','S','M','L','XL','XXL','2XL','3XL']; sizes.sort((a,b)=>{const x=order.indexOf(a),y=order.indexOf(b);return x>=0&&y>=0?x-y:a.localeCompare(b,undefined,{numeric:true});});
    sizes.forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;size.append(option);});
    const update=()=>{let count=0;items.forEach(item=>{item.hidden=(stock.checked&&item.dataset.available!=='true')||(size.value&&!item.dataset.sizes.split('|').includes(size.value));if(!item.hidden)count++;});
      items.sort((a,b)=>sort.value==='featured'?Number(a.dataset.order)-Number(b.dataset.order):sort.value==='low'?Number(a.dataset.price)-Number(b.dataset.price):Number(b.dataset.price)-Number(a.dataset.price)).forEach(item=>grid.append(item));
      this.querySelector('[data-count]').textContent=count+' pieces';this.querySelector('[data-empty]').hidden=count!==0;
    };[size,stock,sort].forEach(control=>control.addEventListener('change',update));update();
  }
}
if(!customElements.get('watany-browse'))customElements.define('watany-browse',WatanyBrowse);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watany-cart-drawer"]) return;
  try {
    
  class WatanyCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.onKeydown = this.onKeydown.bind(this);
      this.addEventListener('click', (event) => this.onClick(event));
      document.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-cart-toggle]');
        if (toggle) {
          event.preventDefault();
          this.open();
        }
      });
      window.addEventListener('watany:cart-add', (event) => {
        this.addItem(event.detail);
      });
    }

    onClick(event) {
      if (event.target.closest('[data-bag-overlay]') || event.target.closest('[data-bag-close]')) {
        this.close();
        return;
      }
      const qty = event.target.closest('[data-bag-qty]');
      if (qty) {
        this.change(qty.dataset.key, Number(qty.dataset.to));
        return;
      }
      const remove = event.target.closest('[data-bag-remove]');
      if (remove) {
        this.change(remove.dataset.key, 0);
        return;
      }
      const recoAdd = event.target.closest('[data-reco-add]');
      if (recoAdd) {
        event.preventDefault();
        this.addItem({ id: Number(recoAdd.dataset.variantId) });
      }
    }

    open() {
      this.classList.add('is-open');
      document.body.classList.add('watany-bag-open');
      const drawer = this.querySelector('.watany-bag');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', this.onKeydown);
      const focusTarget = this.querySelector('[data-bag-close]');
      if (focusTarget) focusTarget.focus();
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('watany-bag-open');
      const drawer = this.querySelector('.watany-bag');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', this.onKeydown);
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    async addItem(detail) {
      if (!detail || !detail.id || this.busy) return;
      this.busy = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: detail.id, quantity: detail.quantity || 1 }] }),
        });
        if (!res.ok) {
          let message = 'Sorry, that piece could not be added.';
          try {
            const body = await res.json();
            if (body && body.description) message = body.description;
          } catch (e) {}
          this.open();
          this.flash(message);
          window.dispatchEvent(
            new CustomEvent('watany:cart-error', { detail: { id: detail.id, message: message } })
          );
          return;
        }
        await this.refresh();
        this.open();
        this.flash(detail.label || 'Added to the bag');
        window.dispatchEvent(
          new CustomEvent('watany:cart-added', { detail: { id: detail.id } })
        );
      } catch (error) {
        window.location.href = '/cart';
      } finally {
        this.busy = false;
      }
    }

    async change(key, quantity) {
      if (this.busy) return;
      this.busy = true;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });
        await this.refresh();
        if (!res.ok) {
          let message = 'Sorry, the bag could not be updated.';
          try {
            const body = await res.json();
            if (body && body.description) message = body.description;
          } catch (e) {}
          this.flash(message);
        }
      } catch (error) {
        window.location.reload();
      } finally {
        this.busy = false;
      }
    }

    async refresh() {
      const [sectionRes, cartRes] = await Promise.all([
        fetch(window.location.pathname + '?section_id=' + this.sectionId),
        fetch('/cart.js'),
      ]);
      const markup = await sectionRes.text();
      const fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('watany-cart');
      if (fresh) this.innerHTML = fresh.innerHTML;
      try {
        const cart = await cartRes.json();
        this.updateHeaderCount(cart.item_count);
      } catch (e) {}
    }

    updateHeaderCount(count) {
      document.querySelectorAll('.watany-header__cart-count').forEach((el) => {
        el.textContent = '(' + count + ')';
      });
    }

    flash(message) {
      const strip = this.querySelector('[data-bag-added]');
      if (!strip) return;
      strip.textContent = message;
      strip.hidden = false;
      clearTimeout(this._flashTimer);
      this._flashTimer = setTimeout(() => {
        strip.hidden = true;
      }, 2600);
    }
  }

  if (!customElements.get('watany-cart')) {
    customElements.define('watany-cart', WatanyCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watany-collection"]) return;
  try {
    
  class WatanySort extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('[data-sort]');
      if (!select) return;
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  if (!customElements.get('watany-sort')) {
    customElements.define('watany-sort', WatanySort);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watany-header"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.watany-header__dropdown[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.watany-header__dropdown[open]').forEach(function (menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  var watanyHeader = document.querySelector('.watany-header');
  var headerWrapper = document.querySelector('.shopify-section-group-header-group');
  function setHeaderH() {
    if (watanyHeader) {
      document.documentElement.style.setProperty('--header-h', watanyHeader.offsetHeight + 'px');
    }
  }
  function updateHeaderTop() {
    if (!watanyHeader || !headerWrapper) return;
    // header is position:fixed so wrapper.offsetHeight == utility bar height
    var utilityH = headerWrapper.offsetHeight;
    watanyHeader.style.top = Math.max(0, utilityH - window.scrollY) + 'px';
  }
  setHeaderH();
  updateHeaderTop();
  window.addEventListener('scroll', updateHeaderTop, { passive: true });
  window.addEventListener('resize', function () { setHeaderH(); updateHeaderTop(); }, { passive: true });
  window.addEventListener('load', function () { setHeaderH(); updateHeaderTop(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watany-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('watany-hero-video')) {
    customElements.define('watany-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.abort = new AbortController();
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 760px)');
        this.visible = true;
        const options = { signal: this.abort.signal };
        this.video.addEventListener('playing', () => {
          this.video.classList.add('has-frame');
        }, options);
        this.video.addEventListener('error', () => {
          this.video.classList.remove('has-frame');
        }, options);
        this.mobile.addEventListener('change', () => { this.video.pause(); this.video.removeAttribute('src'); this.video.load(); this.video.classList.remove('has-frame'); this.start(); }, options);
        this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.video.pause(); else this.start(); }, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); else this.start(); }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.start(); else this.video.pause();
        });
        this.observer.observe(this.closest('.watany-hero'));
        this.start();
      }
      start() {
        if (document.hidden || !this.visible || this.reduced.matches) return;
        if (!this.video.getAttribute('src')) {
          const template = this.querySelector(this.mobile.matches ? '[data-mobile-sources]' : '[data-desktop-sources]');
          const sources = [...template.content.querySelectorAll('source')].sort((a,b) => Number(a.dataset.width) - Number(b.dataset.width));
          const target = this.mobile.matches ? 1080 : 1920;
          const source = sources.find(item => Number(item.dataset.width) >= target) || sources.at(-1);
          if (!source) return;
          this.video.src = source.getAttribute('src');
          this.video.muted = true;
        }
        this.video.play().catch(() => { this.video.classList.remove('has-frame'); });
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.video?.pause(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watany-insta-grid"] && !Shopify.designMode) return;
  try {
    
  class WatanyInsta extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-insta-track]');
      this.prev = this.querySelector('[data-insta-prev]');
      this.next = this.querySelector('[data-insta-next]');
      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));
      if (this.scroller) {
        this.updateNav = this.updateNav.bind(this);
        this.scroller.addEventListener('scroll', this.updateNav, { passive: true });
        this.updateNav();
      }
      const auto = this.dataset.autoRevolve === 'true';
      if (auto && this.scroller) {
        const interval = parseInt(this.dataset.revolveInterval, 10) || 4000;
        this.startAutoRevolve(interval);
        this.addEventListener('mouseenter', () => this.stopAutoRevolve());
        this.addEventListener('mouseleave', () => this.startAutoRevolve(interval));
      }
    }

    disconnectedCallback() {
      this.stopAutoRevolve();
    }

    step(direction) {
      if (!this.scroller) return;
      const cell = this.querySelector('.watany-insta__cell');
      const distance = cell ? cell.getBoundingClientRect().width + 1 : 200;
      this.scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    updateNav() {
      if (!this.scroller) return;
      const tol = 4;
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      if (this.prev) this.prev.toggleAttribute('disabled', this.scroller.scrollLeft <= tol);
      if (this.next) this.next.toggleAttribute('disabled', this.scroller.scrollLeft >= max - tol);
    }

    startAutoRevolve(interval) {
      this.stopAutoRevolve();
      this.autoTimer = setInterval(() => {
        if (document.hidden || !this.scroller) return;
        const max = this.scroller.scrollWidth - this.scroller.clientWidth;
        if (this.scroller.scrollLeft >= max - 4) {
          this.scroller.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.step(1);
        }
      }, interval);
    }

    stopAutoRevolve() {
      if (this.autoTimer) {
        clearInterval(this.autoTimer);
        this.autoTimer = null;
      }
    }
  }

  if (!customElements.get('watany-insta')) {
    customElements.define('watany-insta', WatanyInsta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watany-product"]) return;
  try {
    
  class WatanyProduct extends HTMLElement {
    connectedCallback() {
      this.priceEl = this.querySelector('[data-pdp-price]');
      this.addBtn = this.querySelector('[data-pdp-add]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.addPrice = this.querySelector('[data-add-price]');
      this.sticky = this.querySelector('[data-sticky]');
      this.stickyPrice = this.querySelector('[data-sticky-price]');
      this.stickyBtn = this.querySelector('[data-sticky-btn]');
      this.sentinel = this.querySelector('[data-sticky-sentinel]');
      this.addLabelText = this.dataset.addLabel;
      this.soldOutText = this.dataset.soldOutLabel;
      this.onSaleText = this.dataset.onSaleLabel;
      this.adding = false;
      this.available = this.addBtn ? !this.addBtn.disabled : true;

      this.addEventListener('variant:change', (event) => this.update(event.detail.variant));

      this.endAdding = this.endAdding.bind(this);
      window.addEventListener('watany:cart-added', this.endAdding);
      window.addEventListener('watany:cart-error', this.endAdding);

      this.form = this.querySelector('.watany-pdp__form');
      if (this.form && document.querySelector('watany-cart')) {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (this.adding) return;
          const idInput = this.form.querySelector('[name="id"]');
          if (idInput && idInput.value) {
            this.adding = true;
            if (this.addBtn) this.addBtn.disabled = true;
            if (this.stickyBtn) this.stickyBtn.disabled = true;
            window.dispatchEvent(
              new CustomEvent('watany:cart-add', {
                detail: { id: Number(idInput.value), quantity: 1 },
              })
            );
          }
        });
      }

      if (this.sentinel && this.sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.sticky.classList.toggle('is-docked', entry.isIntersecting);
            });
          },
          { rootMargin: '0px 0px -16px 0px' }
        );
        observer.observe(this.sentinel);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('watany:cart-added', this.endAdding);
      window.removeEventListener('watany:cart-error', this.endAdding);
    }

    endAdding() {
      this.adding = false;
      if (this.addBtn) this.addBtn.disabled = !this.available;
      if (this.stickyBtn) this.stickyBtn.disabled = !this.available;
    }

    update(variant) {
      const available = Boolean(variant && variant.available);
      this.available = available;
      if (this.addBtn) this.addBtn.disabled = !available || this.adding;
      if (this.stickyBtn) this.stickyBtn.disabled = !available || this.adding;
      if (this.addLabel) {
        this.addLabel.textContent = available ? this.addLabelText : this.soldOutText;
      }
      if (available) {
        this.renderPrice(variant);
        if (this.addPrice) this.addPrice.textContent = variant.price;
        if (this.stickyPrice) this.stickyPrice.textContent = variant.price;
      } else {
        if (this.addPrice) this.addPrice.textContent = '';
        if (this.stickyPrice) this.stickyPrice.textContent = '';
      }
    }

    renderPrice(variant) {
      if (!this.priceEl) return;
      const wrap = this.priceEl.querySelector('.watany-price');
      const now = this.priceEl.querySelector('.watany-price__now');
      if (now) now.textContent = variant.price;
      if (!wrap) return;
      wrap.classList.toggle('watany-price--on-sale', Boolean(variant.onSale));
      let was = wrap.querySelector('.watany-price__was');
      let badge = wrap.querySelector('.watany-price__badge');
      if (variant.onSale) {
        if (!was) {
          was = document.createElement('s');
          was.className = 'watany-price__was';
          wrap.insertBefore(was, now || null);
        }
        was.textContent = variant.compareAt || '';
        was.hidden = false;
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'watany-price__badge';
          wrap.appendChild(badge);
        }
        badge.textContent = this.onSaleText || '';
        badge.hidden = false;
      } else {
        if (was) was.hidden = true;
        if (badge) badge.hidden = true;
      }
    }
  }

  if (!customElements.get('watany-product')) {
    customElements.define('watany-product', WatanyProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watany-shop-row"] && !Shopify.designMode) return;
  try {
    
  class WatanyRow extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-row-track]');
      this.prev = this.querySelector('[data-row-prev]');
      this.next = this.querySelector('[data-row-next]');
      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));
      if (this.scroller) {
        this.updateNav = this.updateNav.bind(this);
        this.scroller.addEventListener('scroll', this.updateNav, { passive: true });
        this.updateNav();
      }
    }

    step(direction) {
      if (!this.scroller) return;
      const card = this.querySelector('.watany-row__item');
      const distance = card ? card.getBoundingClientRect().width + 24 : 300;
      this.scroller.scrollBy({ left: direction * distance * 2, behavior: 'smooth' });
    }

    updateNav() {
      if (!this.scroller) return;
      const tolerance = 4;
      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
      if (this.prev) {
        this.prev.toggleAttribute('disabled', this.scroller.scrollLeft <= tolerance);
      }
      if (this.next) {
        this.next.toggleAttribute('disabled', this.scroller.scrollLeft >= maxScroll - tolerance);
      }
    }
  }

  if (!customElements.get('watany-row')) {
    customElements.define('watany-row', WatanyRow);
  }

  } catch(e) { console.error(e); }
})();
})();
